module.exports = __webpack_public_path__ + "static/media/manzo_03_full.5e834fa8.jpg";